export default __webpack_public_path__ + "static/media/button-Camera-Off.2f00487b.png";